import { render, staticRenderFns } from "./AiSettings.vue?vue&type=template&id=2cb8c8ad&scoped=true&"
import script from "./AiSettings.vue?vue&type=script&lang=js&"
export * from "./AiSettings.vue?vue&type=script&lang=js&"
import style0 from "./AiSettings.vue?vue&type=style&index=0&id=2cb8c8ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb8c8ad",
  null
  
)

export default component.exports